import http from 'hub-http/clients/apiClient';
import { CONTACT_TYPE_ID, ContactProperties, RegisteredMemberEnums } from '../constants/crmSearch';
const CRM_SEARCH_URI = 'crm-search/search';
export default class CRMSearchAPI {
  static getContactsRegistrationCount(ilsListIds, isRegistered) {
    const registrationStatus = isRegistered ? RegisteredMemberEnums.REGISTERED : RegisteredMemberEnums.UNREGISTERED;
    const crmSearchRequestBody = {
      objectTypeId: CONTACT_TYPE_ID,
      filterGroups: [{
        filters: [{
          property: ContactProperties.LIST_MEMBERSHIP_ID,
          operator: 'IN',
          values: ilsListIds.map(id => `${id}`)
        }, {
          property: ContactProperties.REGISTERED_MEMBER,
          operator: 'EQ',
          value: registrationStatus
        }]
      }]
    };
    return http.post(CRM_SEARCH_URI, {
      data: crmSearchRequestBody
    }).then(responseData => {
      return {
        count: responseData.total
      };
    });
  }
}